import cartFragment from '@/clients/shopify/queries/fragments/cart'
import orderFragment from '@/clients/shopify/queries/fragments/order'
import productFeedFragment from '@/clients/shopify/queries/fragments/product-feed'
import {
  VARIANT_PAGINATION_LIMIT,
  SELLING_PLAN_PAGINATION_LIMIT,
} from '@/constants/shopify'
import { gql } from '@/utilities/commerce'

export const getCartQuery = gql`
  query getCart($cartId: ID!) {
    cart(id: $cartId) {
      ...cart
    }
  }
  ${cartFragment}
`

export const getProductSellingPlansQuery = gql`
query getProductSellingPlans($id: ID!) {
  product(id: $id) {
    sellingPlanGroups(first: ${SELLING_PLAN_PAGINATION_LIMIT}) {
    edges {
      node {
      name
      options {
        name
        values
      }
      sellingPlans(first: ${SELLING_PLAN_PAGINATION_LIMIT}) {
        edges {
        node {
          id
          name
          options {
          name
          value
          }
        }
        }
      }
      }
    }
    }
    variants(first: ${VARIANT_PAGINATION_LIMIT}) {
    edges {
      node {
      sku
      sellingPlanAllocations(first: ${SELLING_PLAN_PAGINATION_LIMIT}) {
        edges {
        node {
          sellingPlan {
          id
          }
        }
        }
      }
      }
    }
    }
  }
  }
`

export const getProductsQuery = gql`
  query getProducts($first: Int) {
    products(first: $first) {
      edges {
        node {
          ...product
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${productFeedFragment}
`

export const getProductsAfterCursorQuery = gql`
  query getProducts($first: Int, $after: String) {
    products(first: $first, after: $after) {
      edges {
        node {
          ...product
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${productFeedFragment}
`

export const getCustomerOrdersQuery = gql`
  query getCustomerOrders(
    $customerAccessToken: String!
    $first: Int
    $after: String
  ) {
    customer(customerAccessToken: $customerAccessToken) {
      orders(first: $first, after: $after, reverse: true) {
        edges {
          cursor
          node {
            ...order
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${orderFragment}
`

export const getCustomerOrderQuery = gql`
  query getCustomerOrder($id: String!, $customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      orders(first: 1, query: $id) {
        edges {
          node {
            ...order
          }
        }
      }
    }
  }
  ${orderFragment}
`
